// extracted by mini-css-extract-plugin
export var cartContainer = "_mx-4";
export var gray = "_mx-1";
export var itemContainer = "_mx-2";
export var itemDetails = "_mx-3";
export var strong = "_mx-0";